module.exports = __webpack_public_path__ + "img/painpoint3.dcb42387.png";